import { signInWithPopup, signOut } from "firebase/auth";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db, googleProvider } from "../firebase";

function splitName(displayName = "") {
  const parts = String(displayName || "").trim().split(/\s+/).filter(Boolean);
  const firstName = parts[0] || "";
  const lastName = parts.slice(1).join(" ") || "";
  return { firstName, lastName };
}

export async function loginWithGoogle() {
  const cred = await signInWithPopup(auth, googleProvider);
  const user = cred.user;

  // створюємо/оновлюємо профіль у Firestore
  const ref = doc(db, "users", user.uid);
  const snap = await getDoc(ref);

  const { firstName, lastName } = splitName(user.displayName);

  const baseProfile = {
    uid: user.uid,
    email: user.email || "",
    photoURL: user.photoURL || "",
    displayName: user.displayName || "",
    firstName,
    lastName,
    provider: "google",
    updatedAt: serverTimestamp(),
  };

  if (!snap.exists()) {
    await setDoc(ref, { ...baseProfile, createdAt: serverTimestamp(), dob: "" }, { merge: true });
  } else {
    await setDoc(ref, baseProfile, { merge: true });
  }

  // idToken знадобиться для бекенда (пізніше)
  const idToken = await user.getIdToken();

  return { user, idToken };
}

export async function logout() {
  await signOut(auth);
}
